import axios, { AxiosResponse } from "axios";

type Nullable<T> = T | null;
export interface IPerson {
  TennisId: string;
  NativeFamilyName: string;
  NativeGivenName: string;
  BirthDate: string;
  BirthYear: number;
  NationalityCode: string;
  CountryOfResidenceCode: Nullable<string>;
  Sex: string;
  StandardGivenName: string;
  StandardFamilyName: string;
  AlreadyItfCustomer: boolean;
  AlreadyRegisteredForService: boolean;
  RegistrationToken: string;
}

export interface IPersonProps {
  familyName: string;
  givenName: string;
  emailAddress: string;
  dob: string;
  nationality: string;
  country: string;
  gender: string;
}

export const createTennisIDSignUp = ({
  data
}: {
  data: IPersonProps;
}): Promise<AxiosResponse<IPerson>> => {
  return axios({
    method: "post",
    url: `${process.env.HOST}/tennis/api/PlayerCoreDetailsApi/RegisterPerson`,
    data: {
      ...data
    }
  });
};
